import * as React from "react"
import { type IntervalOrigin } from "@digits-graphql/frontend/graphql-bearer"
import { type DigitsButtonProps } from "@digits-shared/DesignSystem/Button"
import useRouter from "@digits-shared/hooks/useRouter"
import { type CSSProp } from "styled-components"
import { useFrontendPathGenerator } from "src/frontend/hooks/useFrontendPathGenerator"
import routes from "src/frontend/routes"
import { type DateRangeIntervalOptions } from "src/shared/components/DateRangeSelector/dateRangeConstants"
import { usePeriodSelectorActiveOrigin } from "src/shared/components/PeriodSelector/usePeriodSelectorActiveOrigin"
import { ActivePeriodButton } from "./ActivePeriod"
import { PeriodSelectorBase } from "./PeriodSelectorBase"

export type PeriodSelectButtonProps = DigitsButtonProps & {
  className?: string
  dateRangeCSS?: CSSProp
  intervals?: DateRangeIntervalOptions
}

export const PeriodSelectorButton: React.FC<PeriodSelectButtonProps> = ({
  className,
  dateRangeCSS,
  intervals,
  ...buttonProps
}) => {
  const [activeOrigin, setActiveOrigin] = usePeriodSelectorActiveOrigin()
  const generatePath = useFrontendPathGenerator()
  const { location, history } = useRouter()

  const onOriginSelected = React.useCallback(
    (newIntervalOrigin: IntervalOrigin) => {
      const urlParams = {
        ...newIntervalOrigin,
      }
      if (urlParams.intervalCount === 1) urlParams.intervalCount = undefined

      const path = generatePath(routes[location.name], urlParams, ["other", "tab"])
      history.replace(path)
    },
    [generatePath, history, location.name]
  )

  return (
    <PeriodSelectorBase
      activeOrigin={activeOrigin}
      setActiveOrigin={setActiveOrigin}
      onOriginSelected={onOriginSelected}
      className={className}
      dateRangeCSS={dateRangeCSS}
      intervals={intervals}
    >
      <ActivePeriodButton activeOrigin={activeOrigin} {...buttonProps} />
    </PeriodSelectorBase>
  )
}
